// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Pn-z","badgeLink":"Qn-z","category":"Rn-z"};